import { Component, ComponentFactoryResolver, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserWizardComponent } from "../user.wizard";
import { ApplicationEmailWizardService } from "./user.email.service";
import { UserEmailNotificationComponent } from "./user.email.notification.component";
import { ValuesExchangeProvider } from "@nrwl/common-lib";

@Component({
  selector: "application-wizard",
  providers: [ApplicationEmailWizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../wizard.user.style.scss", "../../../wizard.button.style.scss"]
})
export class UserEmailNotificationWizard extends UserWizardComponent {

  constructor(
    wizardService: ApplicationEmailWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
    super(wizardService, changeDetectorRef, activatedRoute, factoryResolver);
  }

  resolveComponentType(pageId: any) {
    if (pageId === "user.email.notification.component.html") {
      return UserEmailNotificationComponent;
    } else {
      console.error("Unrecognized template name:", pageId);
      return null;
    }
  }

  toggleFinish() {
    const appObject = this.wizardService.onApply();
    if (appObject && appObject.selectedApps) {
      this.exchange.notifyListeners("selectedApps", appObject.selectedApps);
    }
    this.toggleClose();
  }

}
